export const PATTERN_TYPE_DIFF_LABEL = 'Pattern Type';
export const DEPLOYMENT_HOST_FORM_CONTROL_NAME = 'DEPLOYMENT_HOST';
export const PATTERN_NOTES_FORM_CONTROL_NAME = 'PATTERN_NOTES';
